import { OmpCanvasId } from '../constants/vdp';

const scrollToTop = (isOmp = false) => {
  if (isOmp) {
    const canvas = window.document.getElementById(OmpCanvasId);
    if (canvas) {
      canvas.scrollTop = 0;
    }
  } else {
    window.scrollTo(0, 0);
  }
};

export default scrollToTop;
